import React from "react";

function RecentOrder(props) {
    return (
        <div className="flex items-center justify-between p-4 border rounded-lg">
            <div className="flex items-center space-x-3">
                {/*<img
                    src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-2.jpg"
                    alt="Customer"
                    className="w-10 h-10 rounded-full"
                />*/}
                <div>
                    <p className="font-medium text-gray-800">{props.orderOwnerName}</p>
                    <p className="text-sm text-gray-500">{props.orderID}</p>
                </div>
            </div>
            <div className="text-right">
                <p className="font-semibold text-gray-800">€{props.totalPrice}</p>
                <span className="inline-block px-2 py-1 text-xs bg-green-100 text-green-800 rounded-full">
                      {props.status}
                    </span>
            </div>
        </div>
    );

};

export default RecentOrder;